import { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import FirmaDocumentosFisicosDetailContainer from '../../components/firmas-documentos-fisicos-detail-container/FirmaDocumentosFisicosDetailContainer';

class FirmasDocumentosFisicosDetail extends Component {
  render() {
    return (
      <div>
        <FirmaDocumentosFisicosDetailContainer id={this.props.match.params.id} />
      </div>
    );
  }
}

FirmasDocumentosFisicosDetail.propTypes = {
  match: PropTypes.object,
};

export default withRouter(FirmasDocumentosFisicosDetail);
